const ScanResultTypes = {
  BACK_TO_TRUNKRS: 'BACK_TO_TRUNKRS',
  KEEP_IN_REGION: 'KEEP_IN_REGION',
  ERROR: 'ERROR',
  UNSCANNABLE: 'UNSCANNABLE',
  IN_DAY_NETWORK: 'IN_DAY_NETWORK',
} as const

type ScanResultTypesKeys =
  (typeof ScanResultTypes)[keyof typeof ScanResultTypes]

export default ScanResultTypes
export type { ScanResultTypesKeys }
